import { render, staticRenderFns } from "./Attributes.vue?vue&type=template&id=1ad16c2f"
import script from "./Attributes.vue?vue&type=script&lang=js"
export * from "./Attributes.vue?vue&type=script&lang=js"
import style0 from "./Attributes.vue?vue&type=style&index=0&id=1ad16c2f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports